import { render } from "./WorkflowStepNode.vue?vue&type=template&id=38b314e2&scoped=true"
import script from "./WorkflowStepNode.vue?vue&type=script&lang=js"
export * from "./WorkflowStepNode.vue?vue&type=script&lang=js"

import "./WorkflowStepNode.vue?vue&type=style&index=0&id=38b314e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b314e2"]])

export default __exports__